import type { DownloadableFile } from '@/features/rag/types';

interface DeleteFilesResponse {
  message: string;
  successfulDeletions: string[];
  failedDeletions?: { file: string; error: string }[];
}

export const removeFiles = async (filesToRemove: DownloadableFile[], toolCustomizationId: string) => {
  // Call whatever endpoint handles file deletion
  const response = await fetch('/api/files/assistant/upload', {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      toolCustomizationId,
      fileNames: filesToRemove.map((f) => f.name),
    }),
  });

  if (!response.ok) {
    let errorMsg = response.statusText;
    try {
      const errData = await response.json<{ message: string }>();
      errorMsg = errData?.message || errorMsg;
    } catch {
      // ignore
    }
    return { errorMsg };
  }

  const data: DeleteFilesResponse = await response.json();
  return { data };
};
